<div class="reading-page doc-page">
  <div id="head" class="section-header">
    <h2 class="section-title">LangMi Teacher Terms</h2>
  </div>
  <app-policy-card [policyBody]="body">
    <!-- Body -->
    <ng-template #body>
      <div class="policy-content">
        <p><strong>Last updated: 26 September 2026</strong></p>
        <p>These Teacher Terms ("Teacher Terms") apply to the <strong>teacher profile</strong> of the
          <strong>LangMi</strong> mobile application, published by <strong>Codigrate OÜ</strong>, a private limited company registered in Estonia
          (<a [href]="environmentCommon.company.website">{{ environmentCommon.company.website }}</a>). They add to the
          <a routerLink="{{URLS.langmiTerms}}">LangMi Terms of Use</a>, which continue to apply. You accept the Teacher
          Terms inside the App when you enable the teacher profile; if you do not accept them, the teacher profile stays
          off and everything else in LangMi keeps working.</p>

        <p><strong>1. Who can enable the teacher profile</strong></p>
        <p>The teacher profile is available to LangMi Pro subscribers who are at least 18 years old and legally able to
          enter into agreements. You enable it in <strong>Settings › Account › Enable teacher profile</strong>. We do
          not verify teaching qualifications; enabling the profile is not a certification, endorsement or employment by
          Codigrate.</p>

        <p><strong>2. What the teacher profile does</strong></p>
        <p>A student who also has LangMi Pro can generate a short code inside the App and share it with you. With that
          code you join the student's story and <strong>LangMi only lets the two of you play it together</strong>: your
          own copy of the App follows the same chapter, step and answers, and you can point at something, highlight
          parts of the chapter's grammar page, send a confetti cheer and leave written notes the student reads on their
          Today page. The student sees your display name and can end the session at any time. The App does not share,
          stream or record the student's device screen, carries no voice or video, and you do not control the
          student's device.</p>

        <p><strong>3. An independent relationship</strong></p>
        <p>LangMi is a tool, not a marketplace or an intermediary. We do not match teachers with students, we do not
          process payments between you, we do not set fees, schedules or lesson content, and we are not a party to any
          arrangement you make with a student. Anything you agree with a student — lessons, prices, timing, cancellations
          — is solely between you and them, and you are responsible for any tax, licensing or professional rules that
          apply to your teaching.</p>

        <p><strong>4. Students who are minors</strong></p>
        <p>If a student is under 18, or under the age of digital consent in their country, you may use the teacher
          profile with them <strong>only with the knowledge and consent of a parent, guardian or their school</strong>,
          and only in line with the child-protection laws and institutional rules that apply to you. Codigrate cannot
          check a student's age; this responsibility is yours.</p>

        <p><strong>5. Conduct</strong></p>
        <p>You agree to be respectful and appropriate at all times; to use notes only for learning and feedback; not to
          harass, discriminate, threaten, or send sexual, violent or otherwise inappropriate content; not to advertise,
          sell or solicit through the App; not to ask a student for personal information beyond what the App shows;
          not to record, screenshot, stream or share what you see in a session (a student's progress or answers)
          outside it without their (or their guardian's) consent; and to keep session codes private and use them only with the student who
          gave them to you.</p>

        <p><strong>6. What you see, and how you may use it</strong></p>
        <p>During a session you see the student's display name, their chapter progress, the step of the story you are
          playing together, the answers they give and, in speaking exercises, the text that speech recognition understood
          them to say. Between sessions the "My students" list shows the students you have taught, the chapters you
          finished together, short summaries of your lessons and the student's mistakes list. This information is provided <strong>only so that you can teach that
          student</strong>. Treat it as confidential: do not copy it into other systems, publish it, pass it to third
          parties or use it for any purpose other than teaching that student.</p>

        <p><strong>7. Notes and your data</strong></p>
        <p>Notes you write are stored on our servers, are visible only to the student they are addressed
          to, and can be edited or deleted by you at any time. Your display name is shown to students you learn with.
          Session records (which student, when, which chapter) and lesson summaries are kept so the "My students" list
          works. A student can remove you from their teachers at any time. Deleting your account from
          <strong>Settings › Account</strong> removes your profile and your sessions from our
          servers. Notes and lesson summaries you wrote are part of your students' lessons: they stay with each student,
          shown with your display name, until that student deletes their own account. Delete any note you do not want
          kept before deleting your account. How
          this information is handled is described in the
          <a routerLink="{{URLS.langmiPrivacy}}">LangMi Privacy Policy</a>.</p>

        <p><strong>8. Availability and changes</strong></p>
        <p>The teacher profile needs an active LangMi Pro subscription on both sides and an internet connection. We
          may change, limit or withdraw the feature, and we may update these Teacher Terms; the date at the top shows
          when they last changed. If a change is significant, the App will ask you to accept the new version before you
          continue using the teacher profile.</p>

        <p><strong>9. Suspension</strong></p>
        <p>If you breach these Teacher Terms or the LangMi Terms of Use, or if a student reports conduct that we
          reasonably believe breaches them, we may switch off your teacher profile, end active sessions and, in serious
          cases, close your account, without refund of any subscription period already paid.</p>

        <p><strong>10. No guarantee of results</strong></p>
        <p>LangMi is a language-learning aid. We do not guarantee any learning outcome from lessons given through the
          teacher profile, and we are not responsible for the quality, content or consequences of your teaching. The
          limitation of liability in the <a routerLink="{{URLS.langmiTerms}}">LangMi Terms of Use</a> applies to the
          teacher profile as well.</p>

        <p><strong>11. Governing law and contact</strong></p>
        <p>These Teacher Terms are governed by the laws of Estonia, without prejudice to any mandatory rules of the
          country in which you reside that cannot be set aside by agreement. Disputes are first raised with us by e-mail;
          we try to settle them amicably. Questions can be sent to
          <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>.</p>
      </div>
    </ng-template>
  </app-policy-card>
</div>
